'use strict';

var React = require('react');
require('../../theme/breakpoints.js');
require('imask');
var useMaybeControlledValue = require('../../hooks/useMaybeControlledValue.js');
require('resize-observer-polyfill');
var component$1 = require('../Divider/component.js');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Accordion = React.forwardRef(({ summary, isOpened: isOpenedFromProps, onOpenedChange: onOpenedChangeFromProps, defaultOpened = false, icon, divider, children, px = 'l', py = 'm', pxContent, pyContent, disabled = false, ...props }, ref) => {
    const [accordionChild, setAccordionChild] = React.useState(null);
    const accordionChildHeight = accordionChild?.getBoundingClientRect().height ?? 0;
    const [isOpened, onOpenedChange] = useMaybeControlledValue.useMaybeControlledValue({
        valueFromProps: isOpenedFromProps,
        onChangeFromProps: onOpenedChangeFromProps,
        defaultValue: defaultOpened,
    });
    const onClick = React.useCallback(() => (disabled ? undefined : onOpenedChange(!isOpened)), [disabled, onOpenedChange, isOpened]);
    return (React__default.default.createElement("div", { ...props, ref: ref },
        React__default.default.createElement(styles.Styled.SummaryFlexRow, { px: px, py: py, space: "xs", justifyContent: "space-between", alignItems: "center", onClick: onClick, disabled: disabled },
            React__default.default.createElement("div", null, summary),
            React__default.default.createElement("div", null, icon || React__default.default.createElement(component.Icon, { role: "button", name: isOpened ? 'up-filled' : 'down-filled' }))),
        React__default.default.createElement(styles.Styled.Accordion, { maxHeight: isOpened ? `${accordionChildHeight}px` : '0px' },
            React__default.default.createElement(styles.Styled.AccordionContent, { px: pxContent || pxContent === null ? pxContent : px, py: pyContent || pyContent === null ? pyContent : py, isOpened: isOpened, ref: setAccordionChild }, children)),
        divider === undefined ? React__default.default.createElement(component$1.Divider, null) : React__default.default.createElement("div", null, divider)));
});
Accordion.displayName = 'Accordion';

exports.Accordion = Accordion;
//# sourceMappingURL=component.js.map
